import { Outlet, useParams } from 'react-router-dom';
import { Grid } from '@uniqkey-frontend/shared-app';
import ServicePageBreadcrumbs from './components/ServicePageBreadcrumbs';

const ServicePage = () => {
  const params = useParams();
  const { applicationId } = params;

  return (
    <Grid container flexDirection="column" className="min-height-100-percent">
      <Grid item mb={1}>
        <ServicePageBreadcrumbs applicationId={applicationId!} />
      </Grid>
      <Grid item xs>
        <Outlet context={{ applicationId }} />
      </Grid>
    </Grid>
  );
};

export default ServicePage;
